import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';

function Dashboard() {
  const navigate = useNavigate();

  const dashboardCards = [
    {
      title: 'Student Enquiries',
      description: 'Manage student enquiry forms, track demo classes, and follow up on leads',
      icon: '📚',
      route: '/student-enquiries',
      color: 'primary',
      hasAddButton: true,
      addAction: () => navigate('/student-enquiries', { state: { openAddModal: true } })
    },
    {
      title: 'Tutor Enquiries',
      description: 'Manage tutor applications, verify credentials, and track availability',
      icon: '👨‍🏫',
      route: '/tutor-enquiries',
      color: 'success',
      hasAddButton: true,
      addAction: () => navigate('/tutor-enquiries', { state: { openAddModal: true } })
    },
    {
      title: 'Finalized Students',
      description: 'View and manage active students with assigned tutors and schedules',
      icon: '✅',
      route: '/students',
      color: 'primary'
    },
    {
      title: 'Finalized Tutors',
      description: 'Manage active tutors, their assignments, and availability',
      icon: '🎓',
      route: '/tutors',
      color: 'success'
    },
    {
      title: 'Accounts & Payments',
      description: 'Track fees collection, tutor payouts, and financial transactions',
      icon: '💰',
      route: '/accounts',
      color: 'warning'
    },
    {
      title: 'Settings',
      description: 'Configure dropdown options for schools, classes, subjects, and areas',
      icon: '⚙️',
      route: '/metadata',
      color: 'secondary'
    }
  ];

  const handleCardClick = (card, e) => {
    // Don't navigate if clicking the add button
    if (e.target.closest('.dashboard-card-add-btn')) {
      return;
    }
    navigate(card.route);
  };

  return (
    <div className="dashboard-container">
      <div className="page-header" style={{ marginBottom: '16px' }}>
        <h1 style={{ fontSize: '28px', marginBottom: '4px' }}>Dashboard</h1>
        <p>Welcome to Sai Tutorials Management System</p>
      </div>

      <div className="dashboard-grid">
        {dashboardCards.map((card, index) => (
          <div
            key={index}
            className={`dashboard-card dashboard-card-${card.color}`}
            onClick={(e) => handleCardClick(card, e)}
          >
            {card.hasAddButton && (
              <button
                className="dashboard-card-add-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  card.addAction();
                }}
                title="Add New"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
                </svg>
              </button>
            )}
            <div className="dashboard-card-icon">
              {card.icon}
            </div>
            <h3 className="dashboard-card-title">{card.title}</h3>
            <p className="dashboard-card-description">{card.description}</p>
            <div className="dashboard-card-arrow">→</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Dashboard;
